import React from "react";

interface DropdownProps {
  label: string | number;
  options: { value: string | number; label: string | number }[];
  error?: string;
  onChange?: (value: string) => void;
  value?: string | number;
  className?: string;
}

export const Dropdown: React.FC<DropdownProps> = ({
  label,
  options,
  error,
  onChange,
  value,
  className = "",
}) => {
  return (
    <div className={`w-full ${className}`}>
      {/* Label */}
      <label className="block text-sm font-medium text-gray-700 mb-1 text-left">
        {label}
      </label>

      {/* Dropdown */}
      <div>
        <select
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          className={`w-full border bg-white ${
            error ? "border-red-500" : "border-gray-500"
          } px-3 py-2 rounded shadow-sm focus:outline-none focus:ring-1 ${
            error ? "focus:ring-red-500" : "focus:ring-gray-500"
          }`}
        >
          <option value="" disabled selected>
            Select an option
          </option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Error Message */}
      {error && <p className="text-sm text-left text-red-500 mt-1">{error}</p>}
    </div>
  );
};
